import { animare } from './animare.js';
export default animare;

export * from './types.js';
